import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4601Model } from './kymw4601.model';
import { KYMW4601InputModel } from './vo/kymw4601-input.model';
import { KYMW4601OutputModel } from './vo/kymw4601-output.model';
import { TagInfo } from './vo/tag-info.model';
import { AggregateTagService } from './api-services/aggregate-tag.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import {
  FlexGrid,
  DataMap,
  CellEditEndingEventArgs,
  CellType,
} from '@grapecity/wijmo.grid';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { EventArgs } from '@grapecity/wijmo';

/**
 * タグ集約を管理するクラス
 *
 * @export KYMW4601Component
 * @class KYMW4601Component
 */
@Component({
  selector: 'app-kymw4601',
  templateUrl: 'kymw4601.component.html',
  styleUrls: ['kymw4601.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW4601Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit
{
  @ViewChild('dtg_TagList', { static: false }) dtg_TagList: FlexGrid;
  @ViewChild('btn_Aggregate', { static: false }) btn_Aggregate: ElementRef;

  public model: KYMW4601Model = new KYMW4601Model();
  // 処理成否 (呼び出し側の画面再読み込み判定で利用)
  private procDone = false;

  // ラジオボタン用データマップ
  public dataMap: DataMap = new DataMap(
    [{ val: KYMW4601Model.RADIO_VAL_TRUE, name: '' }],
    'val',
    'name'
  );

  /**
   * Creates an instance of KYMW4601Component.
   *
   * @param {PlessDialogServiceSub} dialogService
   * @param {AggregateTagService} aggregateTagService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW4601Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private aggregateTagService: AggregateTagService,
    private kymw00Model: KYMW00Model
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW4601Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4601';

    // 1行目 選択
    this.model.tagList[0].radioVal = KYMW4601Model.RADIO_VAL_TRUE;
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW4601Component
   */
  public ngAfterViewInit(): void {
    // グリッドのハンドラー設定
    if (this.dtg_TagList) {
      this.dtg_TagList.itemsSourceChanged.addHandler(
        (_g: FlexGrid, _e: EventArgs) => {
          _g.select(-1, -1);
        }
      );
      // ラジオボタンあたり判定制御
      this.dtg_TagList.hostElement.addEventListener('click', e => {
        const ht = this.dtg_TagList.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell && ht.col === 0) {
          this.model.tagList.forEach(
            _ => (_.radioVal = KYMW4601Model.RADIO_VAL_FALSE)
          );
          const target = this.model.tagList.find((e, i) => i === ht.row);
          if (target) target.radioVal = KYMW4601Model.RADIO_VAL_TRUE;

          this.dtg_TagList.collectionView.refresh();
        }
      });
      // 行間のラジオボタンの挙動
      this.dtg_TagList.cellEditEnding.addHandler(
        (_g: FlexGrid, _e: CellEditEndingEventArgs) => {
          this.model.tagList.forEach(
            _ => (_.radioVal = KYMW4601Model.RADIO_VAL_FALSE)
          );
        }
      );
    }
  }

  /**
   * ボタン押下 集約
   *
   * @memberof KYMW4601Component
   */
  public aggregateTags() {
    // バリデーション 入力チェック
    if (!this.model.aggregationTagId || this.model.targetTagIds.length < 1) {
      this.dialogService.openAlertGetMessage('E0103', ['集約先タグ']);
      return;
    }

    // 確認ダイアログ
    this.dialogService.openAlertGetMessage(
      'Q0168',
      [this.model.aggregationTagName],
      _c => {
        if (_c === PlessAlert.Yes) {
          this.aggregateTagService.execute(this.model, calbak);
        }
      }
    );

    const calbak = () => {
      this.dialogService.openAlertGetMessage(
        'I0106',
        ['タグ情報の集約が完了'],
        _e => {
          this.procDone = true;
          this.closeFunction();
        }
      );
    };
  }

  /**
   * パラメータ取得 呼び出し側から利用
   * 処理成否を返却
   *
   * @memberof KYMW4601Component
   */
  public getParams(): KYMW4601OutputModel {
    return { procDone: this.procDone };
  }

  /**
   * パラメータ格納 呼び出し側から利用
   * 集約対象の情報を格納
   *
   * @param data
   * @memberof KYMW4601Component
   */
  public setPrams(data: KYMW4601InputModel): void {
    this.model.tagList = data.map(_ => new TagInfo(_[0], _[1]));
  }
}
